/*!
 * JavaScript Extensions Library.
 *
 * Copyright (C) HaiKom AB 2007-2014
 */
;(function(window) {
	'use strict';

	// Avoid `console` errors in browsers that lack a console.
	var method,
		noop = function () { },
		methods = [
			'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
			'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
			'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
			'timeStamp', 'trace', 'warn'
		],
		length = methods.length,
		console = (window.console = window.console || {});

	while (length-- >= 0) {
		method = methods[length];

		// Only stub undefined methods.
		if (!console[method]) {
			console[method] = noop;
		}
	}
}(window));

// -- Array extension functions.

if (!Array.prototype.forEach) {

  Array.prototype.forEach = function(callback/*, thisArg*/) {
		'use strict';

    var T, k;

    if (this == null) {
      throw new TypeError('this is null or not defined');
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = arguments[1];
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {

      var kValue;

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

if (!Array.prototype.indexOf) {
	/**
	 * indexOf(seachElement) - Searches an array for an element and returns its index (or -1 if it does not exist)
	 * @param {searchElement} The element to check against
	 */
	Array.prototype.indexOf = function (searchElement, fromIndex) {
		'use strict';

		if (this === undefined || this === null) {
			throw new TypeError('"this" is null or not defined');
		}

		var length = this.length >>> 0; // Hack to convert object.length to a UInt32

		fromIndex = +fromIndex || 0;

		if (Math.abs(fromIndex) === Infinity) {
			fromIndex = 0;
		}

		if (fromIndex < 0) {
			fromIndex += length;
			if (fromIndex < 0) {
				fromIndex = 0;
			}
		}

		for (; fromIndex < length; fromIndex++) {
			if (this[fromIndex] === searchElement) {
				return fromIndex;
			}
		}

		return -1;
	};
}

if (!Array.prototype.removeEmpty) {
	/**
	 * removeEmpty() - Removes all empty items from an array (empty strings and null)
	 */
	Array.prototype.removeEmpty = function () {
		'use strict';

		var result = [];
		if (this.length > 0) {
			for (var i = 0; i < result.length; i++) {
				if (this[i] !== null && this[i] !== '') {
					result.push(this[i]);
				}
			}
		}
		return result;
	};
}

if (!Array.prototype.trim) {
	/**
	 * trim() - Trims all string items in an array
	 */
	Array.prototype.trim = function () {
		'use strict';

		var result = this;
		if (result.length > 0) {
			for (var i = 0; i < result.length; i++) {
				if (typeof result[i] === 'string') {
					result[i] = result[i].trim();
				}
			}
		}
		return result;
	};
}

// -- Date extension functions.

if (!Date.prototype.isValid) {
	/**
	 * isValid() - Determines if the date is valid
	 */
	Date.prototype.isValid = function () {
		'use strict';

		return !isNaN(this.getTime());
	};
}

// -- String extension functions.

if (!String.prototype.trim) {
	/**
	 * trim() - Trims the leading and trailing white spaces from a string
	 */
	String.prototype.trim = function () {
		'use strict';

		return this.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	};
}

if (!String.prototype.ltrim) {
	/**
	 * trim() - Trims the leading white spaces from a string
	 */
	String.prototype.ltrim = function () {
		'use strict';

		return this.replace(/^\s+/, '');
	};
}

if (!String.prototype.rtrim) {
	/**
	 * trim() - Trims the trailing white spaces from a string
	 */
	String.prototype.rtrim = function () {
		'use strict';

		return this.replace(/\s+$/, '');
	};
}

if (!String.prototype.startsWith) {
	/**
	 * startsWith(string) - Determines whether a string starts with a string
	 * @param {str} The string to check against
	 */
	String.prototype.startsWith = function (str) {
		'use strict';

		return this.indexOf(str) === 0;
	};
}

if (!String.prototype.endsWith) {
	/**
	 * endsWith(string) - Determines whether a string ends with a string
	 * @param {str} The string to check against
	 */
	String.prototype.endsWith = function (str) {
		'use strict';

		return this.lastIndexOf(str, this.length - (str !== null ? str.length : 0));
	};
}

if (!String.prototype.repeat) {
  String.prototype.repeat = function(count) {
    'use strict';
    if (this == null) {
      throw new TypeError('can\'t convert ' + this + ' to object');
    }
    var str = '' + this;
    count = +count;
    if (count != count) {
      count = 0;
    }
    if (count < 0) {
      throw new RangeError('repeat count must be non-negative');
    }
    if (count == Infinity) {
      throw new RangeError('repeat count must be less than infinity');
    }
    count = Math.floor(count);
    if (str.length == 0 || count == 0) {
      return '';
    }
    // Ensuring count is a 31-bit integer allows us to heavily optimize the
    // main part. But anyway, most current (August 2014) browsers can't handle
    // strings 1 << 28 chars or longer, so:
    if (str.length * count >= 1 << 28) {
      throw new RangeError('repeat count must not overflow maximum string size');
    }
    var rpt = '';
    for (;;) {
      if ((count & 1) == 1) {
        rpt += str;
      }
      count >>>= 1;
      if (count == 0) {
        break;
      }
      str += str;
    }
    // Could we try:
    // return Array(count + 1).join(this);
    return rpt;
  };
}

if (!String.prototype.toJSON) {
	String.prototype.toJSON = function() {
		'use strict';

		var result = {};

		var str = this.trim();

		try {
			result = JSON.parse(str);
		} catch(e) {
			console.warn('Unable to parse', str.toString(), 'to JSON:', e.message);
		}

		return result;
	};
}
